module.exports = __webpack_public_path__ + "img/dataBaseError.2d9fc2aa.png";